import Tippy from "@tippy.js/react";
import { withWindowSize } from "../context/WindowSizeContext";

type Props = {
  content: React.ReactNode;
  children: React.ReactNode;
  windowSize: string;
  windowWidth: number;
  interactive?: boolean;
};

export function PopOver({
  content,
  children,
  windowSize,
  windowWidth,
  interactive,
}: Props) {
  if (!windowSize) {
    return false;
  }

  return (
    <Tippy
      interactive={interactive}
      onTrigger={(_, event) => {
        event.stopPropagation();
      }}
      onUntrigger={
        /* istanbul ignore next */
        (_, event) => {
          event.stopPropagation();
        }
      }
      // @ts-expect-error TS(2322) FIXME: Type 'ReactNode' is not assignable to type 'ReactC... Remove this comment to see the full error message
      content={content}
      trigger="mouseenter click"
      placement={windowSize === "phone" ? "top" : "right"}
      className="pop-over"
      distance={windowSize === "phone" ? 12 : 16}
      offset={windowSize === "phone" ? "00,0" : "350,0"}
      maxWidth={windowSize === "phone" ? windowWidth - 20 : 500}
      appendTo={() => document.body}
    >
      {/* @ts-expect-error TS(2322) FIXME: Type 'ReactNode' is not assignable to type 'ReactE... Remove this comment to see the full error message */}
      {children}
    </Tippy>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '({ content, children, windowSize... Remove this comment to see the full error message
export default withWindowSize(PopOver);
